import { MotivoCancelamento } from './motivo-cancelamento.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class MotivoCancelamentoService {

    constructor(private http: Http) {
    }

    getMotivoCancelamentos(): Observable<MotivoCancelamento[]> {
        return this.http.get(`${NTECH_API}/motivo-cancelamento`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/motivo-cancelamento/motivo-cancelamento.service.ts